module.exports = function(app) {
    app.controller("pages.spending.groupSelection", ["$scope", "session","services", "storage","coremetrics","spendingResourceServices","$cookies","invisibleForm",
        function( $scope, session, services, storage, coremetrics, spendingResourceServices, $cookies, invisibleForm) {

            $scope.viewState = 'loading';
            $scope.clientListSelection="";

            var memberInfo = session.data.memberInfo;
            var spendingAccountDebitCard = function (fullMemberInfo) {
                fullMemberInfo = fullMemberInfo || session.data.memberInfo;
                var clientDebitObj = {};
                var clientDebitList = [];
                var today = new Date();
                today.setHours(0);
                today.setMinutes(0);
                today.setSeconds(0);
                today.setMilliseconds(0);
                for (var i = 0; i < fullMemberInfo.clientList.length; i++) {
                    var client = fullMemberInfo.clientList[i];
                    for (var j = 0; j < client.groupList.length; j++) {
                        var group = client.groupList[j];
                        if (group.spendingAccountExistsIndicator && group.spendingAccountExistsIndicator === "false") {
                            var productList = group.productList; //product list
                            for (var k = 0; k < productList.length; k++) {
                                var product = productList[k];
                                if (productList[k].benefitPlanType !== null) {
                                    var memberList = productList[k].memberList; //member list
                                    var isSubscriber = false;
                                    for (var l = 0; l < memberList.length; l++) {
                                        if ( memberList[l].relationship === "Subscriber") {
                                            isSubscriber = true;
                                            clientDebitObj.clientName = client.clientName;
                                            clientDebitObj.clientNumber = client.clientNumber;
                                            clientDebitObj.groupNumber = group.groupNumber;
                                        }
                                    }
                                    if(isSubscriber){
                                        var coverageBeginDate = new Date(product.coverageBeginDate);
                                        // var coverageEndDate = new Date(product.coverageEndDate);
                                        if (today >= coverageBeginDate) {
                                            console.log(product.benefitPlanName);
                                            clientDebitObj.accountName = product.benefitPlanName;
                                            clientDebitList.push(clientDebitObj);
                                        }
                                    }
                                }
                            }
                            break;
                        }
                    }
                }
                return clientDebitList;
            };
            $scope.clientDebitList = spendingAccountDebitCard(memberInfo);

        }]);
};